"use client"

import { useEffect } from "react"
import Script from "next/script"

import { babackSliceSchema } from "~/components/slices/Baback/_data/schema"
import { WithSafeSliceData } from "~/components/slices/WithSafeSliceData"

function Baback({}) {
  useEffect(() => {
    setTimeout(() => {
      window.baback.open("")
    }, 1000)
  }, [])

  return (
    <Script
      id="baback-script"
      dangerouslySetInnerHTML={{
        __html: `
             (function () {
                docBaback = document;
                if (!window.baback) {
                  window.baback = { providerId: 21714151 };
                } else {
                  window.baback.providerId = 21714151;
                }
                console.log("[baback] loading 21714151");

                const load = ({ orderId, shopNow }) => {
                  s = docBaback.createElement("script");
                  s.src = "https://cdn1.baback.co/index.js";
                  s.type = "module";
                  s.async = 1;
                  docBaback.getElementsByTagName("head")[0].appendChild(s);
                  s.onload = () => {
                    setTimeout(() => {
                      if (window.baback && !shopNow) {
                        window.baback.openPopup({ orderId });
                      }
                    }, 50);
                  };
                };

                docBaback.addEventListener("click", (e) => {
                  const target = e.target;
                  if (
                    target.closest("#baback-trigger") ||
                    target.closest('a[href*="/a/return"]')
                  ) {
                    const urlParams = new URLSearchParams(target.href);
                    const orderId = urlParams.get("orderId") || urlParams.get("order-id") || undefined;
                    e.preventDefault(); // Empêche la navigation vers l'URL du lien
                    load({ orderId });
                  }
                });

                const isShopNow = JSON.parse(localStorage.getItem("baback"))?.state?.step === "shop-now";
                if (isShopNow) {
                  load({ shopNow: true });
                }

                window.baback.open = (params) => {
                  const orderId = params?.orderId || params;
                  load({ shopNow: false, orderId: orderId });
                };
              })();
            `,
      }}
    />
  )
}

export default WithSafeSliceData(
  async function () {
    return <Baback />
  },
  babackSliceSchema,
  "BabackSlice"
)
